import * as app from '../services/app';
import { ActionTypes } from '../types/action-types';

export const expandConfigView = (isExpanded: boolean) => ({
    type: ActionTypes.RDIO_UI_UPDATED,
    configuredExpanded: isExpanded
});

export const installSchema = (enable: boolean) => async dispatch => {
    if (enable) {
        await app.installContextPluginSchema();
        dispatch({
            type: ActionTypes.RDIO_SCHEMA_INSTALLED,
            schemaInstalled: true
        });
    } else {
        await app.uninstallContextPluginSchema();
        dispatch({
            type: ActionTypes.RDIO_SCHEMA_INSTALLED,
            schemaInstalled: false
        });
        dispatch({
            type: ActionTypes.RDIO_UI_UPDATED,
            configuredExpanded: false
        });
    }
};




// WEBPACK FOOTER //
// ./src/sub-projects/radario/actions/app.ts